export default function IconPlus({ color = "white" }) {
  return (
    <svg width="24px" height="24px" viewBox="0 0 16 16" fill="none">
      <path d="M10 1H6V6L1 6V10H6V15H10V10H15V6L10 6V1Z" fill={color} />
    </svg>
  );
}
